import React from 'react';
import { Box, Container, Typography } from '@mui/material';

interface PanelHeroProps {
  title: string;
  subtitle: React.ReactNode;
  action?: React.ReactNode;
}

export const panelPageSx = {
  minHeight: '100vh',
  bgcolor: '#f5f6f7',
  backgroundImage: 'linear-gradient(135deg, rgba(194,53,53,0.035) 25%, transparent 25%), linear-gradient(315deg, rgba(44,44,44,0.025) 25%, transparent 25%)',
  backgroundSize: '72px 72px',
  '& .MuiPaper-root, & .MuiCard-root': { borderRadius: '8px' },
  '& .MuiTableContainer-root': { overflowX: 'auto', WebkitOverflowScrolling: 'touch' },
  '& .MuiTable-root': { minWidth: { xs: 760, md: '100%' } },
  '& .MuiDialog-paper': { width: { xs: 'calc(100% - 24px)', sm: 'auto' }, m: { xs: 1.5, sm: 4 } },
} as const;

const shapeSx = {
  position: 'absolute',
  border: '1px solid rgba(255,255,255,0.18)',
  pointerEvents: 'none',
} as const;

const PanelHero: React.FC<PanelHeroProps> = ({ title, subtitle, action }) => (
  <Box sx={{ position: 'relative', overflow: 'hidden', bgcolor: '#202529', color: '#fff', py: { xs: 3.5, md: 5 }, borderBottom: '3px solid #C23535' }}>
    <Box sx={{ ...shapeSx, width: 150, height: 150, borderRadius: '50%', top: -78, right: '12%' }} />
    <Box sx={{ ...shapeSx, width: 72, height: 72, transform: 'rotate(45deg)', bottom: -38, right: '32%' }} />
    <Box sx={{ ...shapeSx, width: 26, height: 26, transform: 'rotate(45deg)', top: 24, left: '7%', bgcolor: 'rgba(194,53,53,0.18)', borderColor: 'rgba(194,53,53,0.5)' }} />
    <Box sx={{ position: 'absolute', width: 180, height: 36, borderTop: '1px solid rgba(255,255,255,0.14)', borderBottom: '1px solid rgba(255,255,255,0.08)', transform: 'rotate(-18deg)', left: '38%', bottom: 4 }} />
    <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight={700} color="#fff" sx={{ fontSize: { xs: '1.65rem', md: '2rem' } }}>
            {title}
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.76)', mt: 0.5, fontSize: { xs: '0.85rem', sm: '0.95rem' } }}>
            {subtitle}
          </Typography>
        </Box>
        {action && <Box sx={{ width: { xs: '100%', sm: 'auto' }, '& .MuiButton-root': { width: { xs: '100%', sm: 'auto' } } }}>{action}</Box>}
      </Box>
    </Container>
  </Box>
);

export default PanelHero;
